import type { Media } from "@/types/media";

export const movies: Media[] = [
  {
    id: "m1",
    title: "星际迷航者",
    titleEn: "Starlight Voyager",
    kind: "movie",
    genres: ["科幻", "冒险"],
    region: "中国大陆",
    year: 2024,
    rating: 8.7,
    poster:
      "https://readdy.ai/api/search-image?query=epic%20science%20fiction%20movie%20poster%20of%20a%20lone%20astronaut%20standing%20before%20a%20vast%20glowing%20nebula%20and%20a%20distant%20spaceship%2C%20deep%20space%20atmosphere%20with%20orange%20and%20teal%20stellar%20light%2C%20dramatic%20cinematic%20lighting%20and%20ultra%20rich%20detail&width=600&height=900&seq=movie-01-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20astronaut%20silhouette%20gazing%20at%20a%20huge%20orange%20and%20teal%20nebula%20from%20a%20spaceship%20window%2C%20deep%20space%20with%20glowing%20stars%20and%20dramatic%20rim%20light%2C%20moody%20sci%20fi%20film%20atmosphere%2C%20epic%20scale%20and%20high%20detail&width=1600&height=900&seq=movie-01-backdrop&orientation=landscape",
    director: "陆沉",
    cast: ["张亦辰", "林知夏", "周牧"],
    synopsis:
      "一艘失联多年的深空探索飞船突然传回信号，年轻的领航员踏上穿越星海的救援之旅，却在航途中揭开了人类深空计划隐藏多年的终极秘密。",
    duration: "126分钟",
    views: 2340000,
  },
  {
    id: "m2",
    title: "暗夜追凶",
    titleEn: "Night Pursuit",
    kind: "movie",
    genres: ["犯罪", "悬疑"],
    region: "香港",
    year: 2023,
    rating: 8.2,
    poster:
      "https://readdy.ai/api/search-image?query=moody%20crime%20thriller%20movie%20poster%20of%20a%20detective%20in%20a%20rainy%20neon%20lit%20alley%20at%20night%2C%20wet%20asphalt%20reflecting%20warm%20amber%20lights%2C%20film%20noir%20shadows%20and%20tense%20atmosphere%2C%20cinematic%20high%20contrast%20photography&width=600&height=900&seq=movie-02-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=moody%20crime%20thriller%20movie%20poster%20of%20a%20detective%20in%20a%20rainy%20neon%20lit%20alley%20at%20night%2C%20wet%20asphalt%20reflecting%20warm%20amber%20lights%2C%20film%20noir%20shadows%20and%20tense%20atmosphere%2C%20cinematic%20high%20contrast%20photography&width=600&height=900&seq=movie-02-poster&orientation=portrait",
    director: "陈国威",
    cast: ["梁振宇", "苏婉婷"],
    synopsis:
      "一名刑警在追踪连环案件时，发现所有线索都指向多年未解的一桩旧案，而真凶就藏在他最信任的人之中。",
    duration: "118分钟",
    views: 1890000,
  },
  {
    id: "m3",
    title: "时光情书",
    titleEn: "Letters in Time",
    kind: "movie",
    genres: ["爱情", "剧情"],
    region: "中国大陆",
    year: 2024,
    rating: 7.9,
    poster:
      "https://readdy.ai/api/search-image?query=romantic%20drama%20movie%20poster%20of%20an%20old%20bookstore%20with%20sunlight%20streaming%20through%20dusty%20windows%2C%20stacked%20letters%20and%20a%20single%20rose%20on%20a%20wooden%20desk%2C%20warm%20golden%20nostalgic%20tone%2C%20soft%20cinematic%20lighting&width=600&height=900&seq=movie-03-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=romantic%20drama%20movie%20poster%20of%20an%20old%20bookstore%20with%20sunlight%20streaming%20through%20dusty%20windows%2C%20stacked%20letters%20and%20a%20single%20rose%20on%20a%20wooden%20desk%2C%20warm%20golden%20nostalgic%20tone%2C%20soft%20cinematic%20lighting&width=600&height=900&seq=movie-03-poster&orientation=portrait",
    director: "沈婉",
    cast: ["顾南", "江雨桐"],
    synopsis:
      "一封跨越十年的情书在旧书店被发现，两个不同年代的恋人以文字相遇，书写出一段温柔而遗憾的爱情故事。",
    duration: "112分钟",
    views: 1420000,
  },
  {
    id: "m4",
    title: "龙脊长城",
    titleEn: "Dragon Ridge",
    kind: "movie",
    genres: ["动作", "历史"],
    region: "中国大陆",
    year: 2023,
    rating: 8.5,
    poster:
      "https://readdy.ai/api/search-image?query=epic%20historical%20war%20movie%20poster%20of%20armored%20soldiers%20standing%20on%20a%20great%20stone%20wall%20in%20misty%20mountains%2C%20banners%20flying%20and%20torches%20glowing%20orange%20against%20cold%20blue%20dawn%2C%20dramatic%20cinematic%20scale%20and%20detail&width=600&height=900&seq=movie-04-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20battlefield%20scene%20of%20ancient%20armored%20warriors%20defending%20a%20mountain%20fortress%20wall%20at%20dawn%2C%20billowing%20smoke%20and%20glowing%20torchlight%20in%20orange%20and%20desaturated%20tones%2C%20epic%20scale%20and%20highly%20detailed%20historical%20war%20atmosphere&width=1600&height=900&seq=movie-04-backdrop&orientation=landscape",
    director: "韩烈",
    cast: ["秦戈", "白澜", "赵峰"],
    synopsis:
      "边关烽火再起，一支孤立无援的守军死守关隘，用血肉之躯筑起家国最后一道屏障，写下悲壮的守城传奇。",
    duration: "140分钟",
    views: 2680000,
  },
  {
    id: "m5",
    title: "深海回响",
    titleEn: "Echoes of the Deep",
    kind: "movie",
    genres: ["科幻", "悬疑"],
    region: "美国",
    year: 2024,
    rating: 8.0,
    poster:
      "https://readdy.ai/api/search-image?query=deep%20sea%20science%20fiction%20thriller%20movie%20poster%20of%20a%20submarine%20descending%20into%20a%20dark%20ocean%20trench%20with%20faint%20bioluminescent%20glow%2C%20mysterious%20shadowy%20silhouette%20below%2C%20tense%20cold%20teal%20and%20amber%20cinematic%20lighting&width=600&height=900&seq=movie-05-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=deep%20sea%20science%20fiction%20thriller%20movie%20poster%20of%20a%20submarine%20descending%20into%20a%20dark%20ocean%20trench%20with%20faint%20bioluminescent%20glow%2C%20mysterious%20shadowy%20silhouette%20below%2C%20tense%20cold%20teal%20and%20amber%20cinematic%20lighting&width=600&height=900&seq=movie-05-poster&orientation=portrait",
    director: "Ryan Cole",
    cast: ["艾米·卡特", "杰克·摩尔"],
    synopsis:
      "深潜器在万米海沟捕捉到一段来历不明的声波，科考队逐渐意识到，海底深处并非空无一物，而某种注视正悄然回响。",
    duration: "124分钟",
    views: 1560000,
  },
  {
    id: "m6",
    title: "城市之光",
    titleEn: "City Lights",
    kind: "movie",
    genres: ["剧情"],
    region: "中国大陆",
    year: 2022,
    rating: 7.6,
    poster:
      "https://readdy.ai/api/search-image?query=emotional%20urban%20drama%20movie%20poster%20of%20a%20lone%20delivery%20rider%20under%20city%20streetlights%20at%20night%2C%20rainy%20crosswalk%20with%20warm%20amber%20and%20deep%20indigo%20tones%2C%20thoughtful%20cinematic%20mood%20and%20soft%20bokeh&width=600&height=900&seq=movie-06-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=emotional%20urban%20drama%20movie%20poster%20of%20a%20lone%20delivery%20rider%20under%20city%20streetlights%20at%20night%2C%20rainy%20crosswalk%20with%20warm%20amber%20and%20deep%20indigo%20tones%2C%20thoughtful%20cinematic%20mood%20and%20soft%20bokeh&width=600&height=900&seq=movie-06-poster&orientation=portrait",
    director: "何安",
    cast: ["刘畅", "许晓"],
    synopsis:
      "外卖员与失业青年在深夜的城市里相遇，两个素不相识的陌生人因一次意外的善举，悄然改变了彼此的命运。",
    duration: "108分钟",
    views: 980000,
  },
  {
    id: "m7",
    title: "荒野孤旅",
    titleEn: "Wild Solitude",
    kind: "movie",
    genres: ["冒险", "剧情"],
    region: "加拿大",
    year: 2023,
    rating: 7.8,
    poster:
      "https://readdy.ai/api/search-image?query=survival%20adventure%20movie%20poster%20of%20a%20lone%20hiker%20with%20a%20backpack%20standing%20in%20a%20vast%20misty%20pine%20forest%20at%20dusk%2C%20golden%20light%20breaking%20through%20tall%20trees%2C%20epic%20wilderness%20cinematic%20atmosphere%20and%20rich%20texture&width=600&height=900&seq=movie-07-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=survival%20adventure%20movie%20poster%20of%20a%20lone%20hiker%20with%20a%20backpack%20standing%20in%20a%20vast%20misty%20pine%20forest%20at%20dusk%2C%20golden%20light%20breaking%20through%20tall%20trees%2C%20epic%20wilderness%20cinematic%20atmosphere%20and%20rich%20texture&width=600&height=900&seq=movie-07-poster&orientation=portrait",
    director: "Luke Harris",
    cast: ["汤姆·贝克", "安娜·里斯"],
    synopsis:
      "一场意外让摄影师被困在无人荒野，他必须依靠仅存的求生本能，一字一句地走出一片无边无际的森林。",
    duration: "116分钟",
    views: 760000,
  },
  {
    id: "m8",
    title: "幻梦空间",
    titleEn: "Dreamscape",
    kind: "movie",
    genres: ["奇幻", "冒险"],
    region: "中国大陆",
    year: 2024,
    rating: 8.1,
    poster:
      "https://readdy.ai/api/search-image?query=surreal%20fantasy%20adventure%20movie%20poster%20of%20a%20girl%20standing%20on%20floating%20islands%20among%20glowing%20clouds%20and%20giant%20moon%2C%20dreamlike%20violet%20orange%20and%20teal%20palette%2C%20magical%20cinematic%20lighting%20and%20whimsical%20detail&width=600&height=900&seq=movie-08-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=surreal%20fantasy%20adventure%20movie%20poster%20of%20a%20girl%20standing%20on%20floating%20islands%20among%20glowing%20clouds%20and%20giant%20moon%2C%20dreamlike%20violet%20orange%20and%20teal%20palette%2C%20magical%20cinematic%20lighting%20and%20whimsical%20detail&width=600&height=900&seq=movie-08-poster&orientation=portrait",
    director: "苏黎",
    cast: ["林深", "夏朵"],
    synopsis:
      "少女意外闯入梦境世界，为唤醒沉睡的父亲，她需要在梦与现实的边界完成一场充满想象力与勇气的冒险。",
    duration: "120分钟",
    views: 1340000,
  },
  {
    id: "m9",
    title: "铁血使命",
    titleEn: "Iron Duty",
    kind: "movie",
    genres: ["战争", "动作"],
    region: "中国大陆",
    year: 2021,
    rating: 8.3,
    poster:
      "https://readdy.ai/api/search-image?query=gritty%20war%20action%20movie%20poster%20of%20soldiers%20advancing%20through%20smoke%20and%20embers%20at%20night%2C%20mud%20and%20glowing%20orange%20firelight%2C%20intense%20desaturated%20cinematic%20tone%20with%20dramatic%20shadows%20and%20detail&width=600&height=900&seq=movie-09-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=gritty%20war%20action%20movie%20poster%20of%20soldiers%20advancing%20through%20smoke%20and%20embers%20at%20night%2C%20mud%20and%20glowing%20orange%20firelight%2C%20intense%20desaturated%20cinematic%20tone%20with%20dramatic%20shadows%20and%20detail&width=600&height=900&seq=movie-09-poster&orientation=portrait",
    director: "周正",
    cast: ["王铁", "李铭"],
    synopsis:
      "战火纷飞的年代，一支小队临危受命执行绝密护送任务，在枪林弹雨中诠释了什么是使命，什么是信仰。",
    duration: "132分钟",
    views: 2050000,
  },
  {
    id: "m10",
    title: "温暖的夏日",
    titleEn: "Warm Summer",
    kind: "movie",
    genres: ["喜剧", "家庭"],
    region: "日本",
    year: 2023,
    rating: 7.7,
    poster:
      "https://readdy.ai/api/search-image?query=cozy%20warm%20family%20comedy%20movie%20poster%20of%20a%20small%20seaside%20inn%20with%20lanterns%20and%20sunflowers%20in%20summer%2C%20bright%20cheerful%20golden%20afternoon%20light%2C%20gentle%20nostalgic%20cinematic%20atmosphere%20and%20detail&width=600&height=900&seq=movie-10-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cozy%20warm%20family%20comedy%20movie%20poster%20of%20a%20small%20seaside%20inn%20with%20lanterns%20and%20sunflowers%20in%20summer%2C%20bright%20cheerful%20golden%20afternoon%20light%2C%20gentle%20nostalgic%20cinematic%20atmosphere%20and%20detail&width=600&height=900&seq=movie-10-poster&orientation=portrait",
    director: "佐藤健一",
    cast: ["小林优", "山田绫"],
    synopsis:
      "一家濒临倒闭的旧旅馆，在一个暑假迎来一群古怪的客人，却意外找回了久违的温暖与人情味。",
    duration: "105分钟",
    views: 690000,
  },
  {
    id: "m11",
    title: "迷雾侦探",
    titleEn: "Fog Detective",
    kind: "movie",
    genres: ["悬疑", "犯罪"],
    region: "英国",
    year: 2022,
    rating: 8.4,
    poster:
      "https://readdy.ai/api/search-image?query=atmospheric%20mystery%20movie%20poster%20of%20an%20old%20detective%20with%20a%20lantern%20walking%20through%20a%20thick%20foggy%20village%20street%2C%20dim%20amber%20lamplight%20and%20grey%20mist%2C%20brooding%20victorian%20cinematic%20mood%20and%20texture&width=600&height=900&seq=movie-11-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=atmospheric%20mystery%20movie%20poster%20of%20an%20old%20detective%20with%20a%20lantern%20walking%20through%20a%20thick%20foggy%20village%20street%2C%20dim%20amber%20lamplight%20and%20grey%20mist%2C%20brooding%20victorian%20cinematic%20mood%20and%20texture&width=600&height=900&seq=movie-11-poster&orientation=portrait",
    director: "Oliver Reed",
    cast: ["詹姆斯·霍尔", "克莱尔·艾伦"],
    synopsis:
      "浓雾笼罩的小镇接连发生离奇案件，年迈的侦探抽丝剥茧，一步步揭开小镇隐藏了数十年的秘密。",
    duration: "114分钟",
    views: 1120000,
  },
  {
    id: "m12",
    title: "末日方舟",
    titleEn: "Last Ark",
    kind: "movie",
    genres: ["科幻", "灾难"],
    region: "美国",
    year: 2025,
    rating: 8.6,
    poster:
      "https://readdy.ai/api/search-image?query=post%20apocalyptic%20science%20fiction%20movie%20poster%20of%20a%20massive%20ark%20spaceship%20rising%20above%20a%20stormy%20flooded%20earth%2C%20lightning%20and%20glowing%20orange%20engine%20light%2C%20epic%20disaster%20cinematic%20scale%20and%20high%20detail&width=600&height=900&seq=movie-12-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20colossal%20futuristic%20ark%20spaceship%20launching%20from%20a%20stormy%20flooded%20earth%2C%20dramatic%20lightning%20and%20glowing%20orange%20thruster%20light%20against%20dark%20clouds%2C%20epic%20disaster%20film%20atmosphere%20and%20rich%20detail&width=1600&height=900&seq=movie-12-backdrop&orientation=landscape",
    director: "Sarah Lee",
    cast: ["艾丹·克拉克", "诺拉·金"],
    synopsis:
      "全球灾难降临，人类最后的方舟载着幸存者驶向未知，而船上隐藏的秘密，足以改变所有人的命运。",
    duration: "148分钟",
    views: 3120000,
  },
  {
    id: "m13",
    title: "江湖往事",
    titleEn: "Tales of Jianghu",
    kind: "movie",
    genres: ["动作", "武侠"],
    region: "中国大陆",
    year: 2022,
    rating: 7.9,
    poster:
      "https://readdy.ai/api/search-image?query=stylish%20wuxia%20movie%20poster%20of%20a%20swordsman%20in%20flowing%20robes%20standing%20in%20bamboo%20forest%20at%20dusk%2C%20falling%20leaves%20and%20misty%20golden%20light%2C%20elegant%20martial%20arts%20cinematic%20mood%20and%20detail&width=600&height=900&seq=movie-13-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=stylish%20wuxia%20movie%20poster%20of%20a%20swordsman%20in%20flowing%20robes%20standing%20in%20bamboo%20forest%20at%20dusk%2C%20falling%20leaves%20and%20misty%20golden%20light%2C%20elegant%20martial%20arts%20cinematic%20mood%20and%20detail&width=600&height=900&seq=movie-13-poster&orientation=portrait",
    director: "郭靖川",
    cast: ["燕十三", "柳如烟"],
    synopsis:
      "退隐江湖的剑客为一句承诺重出江湖，与旧友新敌在风雨飘摇的年代里，完成一场宿命般的最后对决。",
    duration: "122分钟",
    views: 1180000,
  },
  {
    id: "m14",
    title: "心动信号",
    titleEn: "Heartbeat Signal",
    kind: "movie",
    genres: ["爱情", "喜剧"],
    region: "韩国",
    year: 2024,
    rating: 7.5,
    poster:
      "https://readdy.ai/api/search-image?query=bright%20romantic%20comedy%20movie%20poster%20of%20a%20cozy%20radio%20studio%20with%20warm%20festoon%20lights%20and%20two%20microphones%2C%20pink%20and%20amber%20playful%20tone%2C%20cheerful%20modern%20cinematic%20lighting%20and%20charm&width=600&height=900&seq=movie-14-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=bright%20romantic%20comedy%20movie%20poster%20of%20a%20cozy%20radio%20studio%20with%20warm%20festoon%20lights%20and%20two%20microphones%2C%20pink%20and%20amber%20playful%20tone%2C%20cheerful%20modern%20cinematic%20lighting%20and%20charm&width=600&height=900&seq=movie-14-poster&orientation=portrait",
    director: "金智恩",
    cast: ["朴志勋", "韩素恩"],
    synopsis:
      "两位电台主播因一次直播事故被迫合作，从互相看不顺眼到渐渐心动，在电波里谈了一场吵吵闹闹的恋爱。",
    duration: "110分钟",
    views: 1050000,
  },
  {
    id: "m15",
    title: "逆风飞翔",
    titleEn: "Against the Wind",
    kind: "movie",
    genres: ["运动", "剧情"],
    region: "中国大陆",
    year: 2023,
    rating: 8.0,
    poster:
      "https://readdy.ai/api/search-image?query=uplifting%20sports%20drama%20movie%20poster%20of%20young%20runners%20training%20on%20a%20mountain%20track%20at%20sunrise%2C%20dust%20and%20warm%20golden%20light%2C%20hopeful%20inspirational%20cinematic%20atmosphere%20and%20energy&width=600&height=900&seq=movie-15-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=uplifting%20sports%20drama%20movie%20poster%20of%20young%20runners%20training%20on%20a%20mountain%20track%20at%20sunrise%2C%20dust%20and%20warm%20golden%20light%2C%20hopeful%20inspirational%20cinematic%20atmosphere%20and%20energy&width=600&height=900&seq=movie-15-poster&orientation=portrait",
    director: "田进",
    cast: ["高远", "陈曦"],
    synopsis:
      "受伤退役的短跑选手回到家乡执教，带领一群山里孩子跑向更远的赛场，也跑回了自己遗失的初心。",
    duration: "118分钟",
    views: 970000,
  },
  {
    id: "m16",
    title: "沉默证词",
    titleEn: "Silent Testimony",
    kind: "movie",
    genres: ["犯罪", "悬疑"],
    region: "中国大陆",
    year: 2024,
    rating: 8.2,
    poster:
      "https://readdy.ai/api/search-image?query=suspenseful%20legal%20thriller%20movie%20poster%20of%20an%20empty%20courtroom%20with%20a%20single%20glass%20of%20water%20on%20the%20table%2C%20cold%20grey%20and%20amber%20light%20through%20tall%20windows%2C%20tense%20cinematic%20mood%20and%20detail&width=600&height=900&seq=movie-16-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=suspenseful%20legal%20thriller%20movie%20poster%20of%20an%20empty%20courtroom%20with%20a%20single%20glass%20of%20water%20on%20the%20table%2C%20cold%20grey%20and%20amber%20light%20through%20tall%20windows%2C%20tense%20cinematic%20mood%20and%20detail&width=600&height=900&seq=movie-16-poster&orientation=portrait",
    director: "罗铮",
    cast: ["沈默", "许宁"],
    synopsis:
      "一桩没有目击者的案件，一段无法开口的证词，年轻的检察官在层层谎言之中，寻找唯一的真相。",
    duration: "126分钟",
    views: 1480000,
  },
  {
    id: "m17",
    title: "山海奇缘",
    titleEn: "Mountains and Seas",
    kind: "movie",
    genres: ["奇幻", "冒险"],
    region: "中国大陆",
    year: 2021,
    rating: 7.6,
    poster:
      "https://readdy.ai/api/search-image?query=fantasy%20adventure%20movie%20poster%20of%20a%20boy%20holding%20a%20glowing%20ancient%20scroll%20beside%20a%20mythical%20beast%20in%20mystic%20mountains%2C%20jade%20green%20and%20amber%20magical%20glow%2C%20epic%20oriental%20fantasy%20cinematic%20lighting&width=600&height=900&seq=movie-17-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=fantasy%20adventure%20movie%20poster%20of%20a%20boy%20holding%20a%20glowing%20ancient%20scroll%20beside%20a%20mythical%20beast%20in%20mystic%20mountains%2C%20jade%20green%20and%20amber%20magical%20glow%2C%20epic%20oriental%20fantasy%20cinematic%20lighting&width=600&height=900&seq=movie-17-poster&orientation=portrait",
    director: "白鹿",
    cast: ["云舟", "青璃"],
    synopsis:
      "少年带着一幅神秘画卷穿越山海异境，与神兽并肩同行，踏上寻找失落神木、解开身世之谜的旅程。",
    duration: "128分钟",
    views: 880000,
  },
  {
    id: "m18",
    title: "极速飞驰",
    titleEn: "Full Throttle",
    kind: "movie",
    genres: ["动作", "运动"],
    region: "德国",
    year: 2023,
    rating: 7.8,
    poster:
      "https://readdy.ai/api/search-image?query=high%20octane%20racing%20action%20movie%20poster%20of%20a%20sports%20car%20drifting%20on%20a%20wet%20city%20highway%20at%20night%2C%20motion%20blur%20and%20glowing%20red%20orange%20taillights%2C%20adrenaline%20cinematic%20speed%20and%20detail&width=600&height=900&seq=movie-18-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=high%20octane%20racing%20action%20movie%20poster%20of%20a%20sports%20car%20drifting%20on%20a%20wet%20city%20highway%20at%20night%2C%20motion%20blur%20and%20glowing%20red%20orange%20taillights%2C%20adrenaline%20cinematic%20speed%20and%20detail&width=600&height=900&seq=movie-18-poster&orientation=portrait",
    director: "Max Weber",
    cast: ["卢卡斯·施奈德", "艾拉·福斯特"],
    synopsis:
      "天才赛车手卷入地下竞速的漩涡，在速度与规则之间寻找属于自己的终点线，也找回了对赛道的热爱。",
    duration: "120分钟",
    views: 1230000,
  },
  {
    id: "m19",
    title: "岁月如歌",
    titleEn: "Years Like Songs",
    kind: "movie",
    genres: ["剧情", "家庭"],
    region: "中国大陆",
    year: 2022,
    rating: 8.1,
    poster:
      "https://readdy.ai/api/search-image?query=nostalgic%20family%20drama%20movie%20poster%20of%20an%20old%20factory%20courtyard%20with%20bicycles%20and%20laundry%20lines%2C%20warm%20sepia%20golden%20afternoon%20light%2C%20tender%20retro%20cinematic%20memory%20and%20detail&width=600&height=900&seq=movie-19-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=nostalgic%20family%20drama%20movie%20poster%20of%20an%20old%20factory%20courtyard%20with%20bicycles%20and%20laundry%20lines%2C%20warm%20sepia%20golden%20afternoon%20light%2C%20tender%20retro%20cinematic%20memory%20and%20detail&width=600&height=900&seq=movie-19-poster&orientation=portrait",
    director: "温言",
    cast: ["周慧", "林建国"],
    synopsis:
      "三代人在一座老厂房里度过了数十年的光阴，时代的变迁中，书写出一段平凡而动人的家庭史诗。",
    duration: "130分钟",
    views: 1090000,
  },
  {
    id: "m20",
    title: "量子边缘",
    titleEn: "Quantum Edge",
    kind: "movie",
    genres: ["科幻", "悬疑"],
    region: "中国大陆",
    year: 2025,
    rating: 8.3,
    poster:
      "https://readdy.ai/api/search-image?query=high%20concept%20science%20fiction%20movie%20poster%20of%20a%20physicist%20before%20a%20glowing%20fractured%20quantum%20sphere%20in%20a%20dark%20lab%2C%20orange%20and%20teal%20energy%20threads%2C%20mind%20bending%20cinematic%20lighting%20and%20intricate%20detail&width=600&height=900&seq=movie-20-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=high%20concept%20science%20fiction%20movie%20poster%20of%20a%20physicist%20before%20a%20glowing%20fractured%20quantum%20sphere%20in%20a%20dark%20lab%2C%20orange%20and%20teal%20energy%20threads%2C%20mind%20bending%20cinematic%20lighting%20and%20intricate%20detail&width=600&height=900&seq=movie-20-poster&orientation=portrait",
    director: "江彻",
    cast: ["顾言", "苏晴"],
    synopsis:
      "物理学家发现世界正被量子误差一点点侵蚀，为了保住记忆中的一切，他必须回到最初的那次实验。",
    duration: "134分钟",
    views: 1760000,
  },
];